
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import StatTaskContent from '@/components/revenue/statTask/StatTaskContent.vue';

@Component({
    beforeRouteLeave(to: any, from: any, next: (arg0?: (vm: any) => void) => void) {
        if (this.getUnsavedDataState) {
            this.setAbortTransition(true);
            this.setRouteToTransition(to.name);
        } else {
            this.setAbortTransition(false);
            this.setRouteToTransition('');
            next();
        }
    },
    components: { StatTaskContent },
})

export default class StatTask extends Vue {
    @Getter('GET_UNSAVED_DATA_STATE') getUnsavedDataState;
    @Mutation('SET_ABORT_TRANSITION') setAbortTransition;
    @Mutation('SET_ROUTE_TO_TRANSITION') setRouteToTransition;

    created(): void {
        this.setAbortTransition(false);
    }
}
